import { setCurrentTheme } from '@redux/actions';
import { ThemeInterface } from '@redux/prop-types';
import { themeSelector } from '@redux/selectors';
import { ThemeEnum } from '@utils/enums/theme-enum';
import React, { ComponentProps, FC, useMemo } from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import './dark-mode-button.css';

export interface DarkModeButtonProps extends ComponentProps<'button'> {
  theme: ThemeInterface;
  setCurrentTheme: (theme: ThemeEnum) => void;
}

const mapStateToProps = createSelector(
  themeSelector,
  (theme: ThemeInterface) => ({ theme })
);
const mapDispatchToProps = {
  setCurrentTheme
};

const DarkModeButton: FC<DarkModeButtonProps> = ({
  setCurrentTheme,
  theme,
  className,
  ...props
}) => {
  const text = useMemo(() => {
    if (theme.currentTheme === ThemeEnum.DARK) {
      return 'Dark Mode';
    }
    return 'Light Mode';
  }, [theme.currentTheme]);

  const toggleTheme = () => {
    if (theme.currentTheme === ThemeEnum.DARK) {
      return setCurrentTheme(ThemeEnum.LIGTH);
    }
    return setCurrentTheme(ThemeEnum.DARK);
  };

  return (
    <button
      onClick={toggleTheme}
      className={['toggle-darkmode nav-item', className].join(' ')}
      {...props}
    >
      <button className='toggle-darkmode-button'>
        <div className='toggle-darkmode-button-ball' />
      </button>
      <span className='toggle-darkmode-text'>{text}</span>
    </button>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(DarkModeButton);
